import Indicador from ".."
import EditFields from "./components/EditFields"
// import MMGraficoPainel from "./components/MMGraficoPainel"
// import MMGraficoRelatorio from "./components/MMGraficoRelatorio"
import { ParamFields } from "./components/ParamFields"
import Report from "./reports"
import ReportSummary from "./reports/summary"

export default class MudaManual extends Indicador {
    static get fullName() {
        return "Muda Manual"
    }

    static get abbrev() {
        return "MManual"
    }

    static get field() {
        return "mudaManual"
    }

    static paramFields(tipoIndicadorField = '') {
        return <ParamFields tipoIndicadorField={tipoIndicadorField} />
    }

    static getEditFields(visita, isNew, TipoClass) {
        return <EditFields visita={visita} isNew={isNew} TipoClass={TipoClass} />
    }

    async renderReport(visita) {
        return Report(this, visita)
    }

    async renderReportSummary(visita, tipoName) {
        return ReportSummary(this, visita, tipoName)
    }

    static calcConformidade(apontamento, params) {
        if (!params) {
            return 0
        }

        // porcentagem do quanto está conforme
        apontamento.despontePerdas = ((apontamento.totalConformeDespontePerdas * 100) / apontamento.totalAvaliadoDespontePerdas).toFixed(2)
        apontamento.desponteNaoDespontada = ((apontamento.totalConformeDesponteNaoDespontada * 100) / apontamento.totalAvaliadoDesponteNaoDespontada).toFixed(2)
        apontamento.gemasDanificadasFacao = ((apontamento.totalConformeGemasDanificadasFacao * 100) / apontamento.totalAvaliadoGemasDanificadasFacao).toFixed(2)
        apontamento.gemasDanificadasPragaClima = ((apontamento.totalConformeGemasDanificadasPragaClima * 100) / apontamento.totalAvaliadoGemasDanificadasPragaClima).toFixed(2)

        return ''
    }

    static getConformidadeStatus(conformidade, meta) {
        return this.calcConformidadeStatus(conformidade, meta, 80, 90, 98)
    }

    static getTableRelApontamentos(paramsCliente, IndicadorClass) { // pdf da tela de relatórios
        return [
            { title: "Data", width: 'auto', getValue: (a) => a.dataRef.split("-").reverse().join('/') },
            { title: "Laudo", field: "laudoRef.sequencialIndex", width: 28 },
            { title: "Cod.", field: "laudoRef.fazenda.codFazenda", width: 'auto' },
            { title: "Fazenda", field: "laudoRef.fazenda.nomeFazenda" },

            { title: "Talhão", field: "talhao.nome" },

            { title: "Frota", field: "trator.numeroFrotaTrator", width: 'auto' },
            { title: "Frente", field: "frente", width: 'auto' },
            { title: "Turno", field: "turno", width: 'auto' },

            {
                title: "D.P.(%)",
                field: "despontePerdas",
                width: 38,
                getColor: a => {
                    return IndicadorClass.getColorStatus(IndicadorClass.getConformidadeStatus(a.despontePerdas, paramsCliente?.despontePerdas))
                }
            },
            {
                title: "D.N.D.(%)",
                field: "desponteNaoDespontada",
                width: 38,
                getColor: a => {
                    return IndicadorClass.getColorStatus(IndicadorClass.getConformidadeStatus(a.desponteNaoDespontada, paramsCliente?.desponteNaoDespontada))
                }
            },
            {
                title: "G.D.F.(%)",
                field: "gemasDanificadasFacao",
                width: 38,
                getColor: a => {
                    return IndicadorClass.getColorStatus(IndicadorClass.getConformidadeStatus(a.gemasDanificadasFacao, paramsCliente?.gemasDanificadasFacao))
                }
            },
            {
                title: "G.D.P.C.(%)",
                field: "gemasDanificadasPragaClima",
                width: 38,
                getColor: a => {
                    return IndicadorClass.getColorStatus(IndicadorClass.getConformidadeStatus(a.gemasDanificadasPragaClima, paramsCliente?.gemasDanificadasPragaClima))
                }
            }
        ]
    }

    static getResultStr(apontamento) {
        return "Desponte (perdas): " + apontamento.tamToletesPicados +
            ", Desponte (Não Despontada): " + apontamento.entrenosRachados +
            ", Gemas Danificadas (Facão): " + apontamento.nosRachados +
            " e Gemas Danificadas (Praga e Clima): " + apontamento.gemasDanificadas
    }
}
